import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import HeroVideo from '../components/HeroVideo';
import Manifesto from '../components/Manifesto';
import PortfolioVideo from '../components/PortfolioVideo';
import About from '../components/About';
import MarketDoesntSee from '../components/MarketDoesntSee';
import GoogleReviews from '../components/GoogleReviews';
import GooglePhotosFeed from '../components/GooglePhotosFeed';
import PartnersSection from '../components/PartnersSection';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';
import { isCrazyWeekActive } from '../utils/crazyWeek';
import { useDocumentSEO } from '../utils/useDocumentSEO';

const HomePage = () => {
  const [, setIsCrazyWeek] = useState(false);

  useEffect(() => {
    setIsCrazyWeek(isCrazyWeekActive());
    const interval = setInterval(() => {
      setIsCrazyWeek(isCrazyWeekActive());
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  useDocumentSEO({
    title:
      'Coutin Agência | Marketing Digital e Produção Audiovisual em Foz do Iguaçu - PR',
    description:
      'Agência de Marketing Digital e Produção Audiovisual em Foz do Iguaçu, Paraná. Especialistas em filmagem 4K, drones FPV, gestão de redes sociais, sites de alta conversão, identidade visual e tráfego pago. Atendemos toda a região da Tríplice Fronteira.',
    canonical: 'https://www.agenciacoutin.com.br/',
  });

  return (
    <div className="App bg-[#0A0A0A]">
      <Header />
      <main>
        <HeroVideo />
        <Manifesto />
        <PortfolioVideo />
        <About />
        <MarketDoesntSee />
        <GoogleReviews />
        <GooglePhotosFeed />
        <PartnersSection />
        <FAQSection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default HomePage;
